import { Badge, FlexBox, Text } from '@dixa/lib-shared-habla';
import classnames from 'classnames';

import { LauncherIconOption } from '../types';

import styles from './styles.module.scss';

interface Props {
  className?: string;
  options: LauncherIconOption[];
  onChange: (id: string) => void;
  value: string;
}

export function LauncherIconPickerField({
  className,
  options,
  onChange,
  value,
}: Props): JSX.Element {
  return (
    <div className={classnames(className, styles.optionsRoot)}>
      {options.map((option) => (
        <Option
          key={option.id}
          option={option}
          onSelect={onChange}
          isSelected={value === option.id}
        />
      ))}
    </div>
  );
}

function Option({
  option,
  isSelected,
  onSelect,
}: {
  option: LauncherIconOption;
  onSelect: (id: string) => void;
  isSelected: boolean;
}): JSX.Element {
  return (
    <FlexBox
      gap="100"
      alignItems="center"
      flexDirection="column"
      justifyContent="center"
      onClick={option.lockedFeature ? undefined : () => onSelect(option.id)}
      className={classnames(styles.launcherIconOption, {
        [styles.launcherIconOptionSelected]: isSelected,
        [styles.launcherIconOptionDisabled]: option.lockedFeature,
      })}
    >
      <FlexBox
        justifyContent="center"
        alignItems="center"
        className={styles.launcherIconOptionPreview}
      >
        <div>{option.icon}</div>
      </FlexBox>

      <div>
        <Text.Paragraph variant="2" color="inherit">
          {option.title}
        </Text.Paragraph>
      </div>

      {option.lockedFeature && (
        <Badge
          size="small"
          variant="secondary"
          className={styles.featureLockedBadge}
        >
          Upgrade to access
        </Badge>
      )}
    </FlexBox>
  );
}
